import type { AppContextEntry } from '../../chat-app-context'
import type { JobsScope } from './components/JobsTable'
import type { LandingTab } from './wizard/IngestLanding'

export interface IngestAppContextInput {
  scope: JobsScope
  tab: LandingTab
}

/** The active tab and jobs-table scope; the route baseline already carries the graph branch. */
export function buildIngestAppContextEntries(input: IngestAppContextInput): AppContextEntry[] {
  return [
    { key: 'Tab', value: input.tab },
    { key: 'Scope', value: input.scope === 'all' ? 'all branches' : 'this branch' }
  ]
}
